import {
  PHOTOGRAPHER_PACKAGE_LIST_VISIBLE_CATEGORY_PACKAGE
} from './events';

const CLASS_NAME = {
  visible: 'list-package-set__item--visible'
};

const SELECTOR = {
  packageList: '.list-package-set__item'
};

const PARAMS = {
  categoryId: 'category_id'
};

class PhotographerPackageList {
  constructor(elementRef) {
    this.elementRef = elementRef;
    this.packageList = this.elementRef.querySelectorAll(SELECTOR['packageList']);

    // Bind functions
    this.onVisibleCategoryPackage = this.onVisibleCategoryPackage.bind(this);

    this._addEventListeners();
  }

  // Event Handlers

  /**
   * Event handler to handle visibility of package list.
   *
   * @param {Event} [event] - custom event.
   * */
  onVisibleCategoryPackage(event) {
    const { categoryId } = event.detail;

    this.packageList.forEach(list => {
      if (list.dataset.packageListId === categoryId) {
        list.classList.add(CLASS_NAME['visible']);
      } else {
        list.classList.remove(CLASS_NAME['visible']);
      }
    });

    this._updateUrlParams(categoryId);
  }

  // Private

  _addEventListeners() {
    this.elementRef.addEventListener(PHOTOGRAPHER_PACKAGE_LIST_VISIBLE_CATEGORY_PACKAGE, this.onVisibleCategoryPackage);
  }

  _updateUrlParams(categoryId) {
    const url = new URLSearchParams(location.search);

    if (url.has(PARAMS['categoryId']) && (url.get(PARAMS['categoryId']) !== categoryId)) {
      url.set(PARAMS['categoryId'], categoryId);
      history.replaceState({ categoryId }, '', `?${url.toString()}`);
    }
  }
}

export default PhotographerPackageList;
